import { createPortal } from 'react-dom';
import HorizontalFilters from '@/app/components/search/components/Filters/HorizontalFilters';
import React, { useContext, useEffect, useState } from 'react';
import { SearchPageContext } from '@/app/components/search/components/SearchPageContainer/SearchPageContext.ts';
import { useSearchPageData } from '@/app/components/search/searchPageDataProvider.tsx';
import useIsClient from '@/app/components/search/hooks/useIsClient.ts';
import useWindowDimensions from '@/app/components/search/hooks/useWindowHandler.tsx';
import type { DynamicFiltersResponse } from '@/app/components/search/utils/api/dynamicFiltersResponseTypes.ts';
import type { RouteType } from '../../../Curiosity';

type Props = {
  routeType: RouteType;
  isWaiting: boolean;
  dynamicFiltersResponse?: DynamicFiltersResponse;
  handleShowFilters: (newShowFilters: boolean) => void;
  isDesktop: boolean;
};

const FiltersBarContainer = ({ routeType, isWaiting, dynamicFiltersResponse, handleShowFilters, isDesktop }: Props) => {
  const isClient = useIsClient();
  const { isLoading } = useSearchPageData();
  const { listView, layoutType } = useContext(SearchPageContext);
  const { width } = useWindowDimensions();
  const [filtersBarContainer, setFiltersBarContainer] = useState<Element | null>(null);

  // Re-query the DOM element whenever client state, listView, layoutType, or window width changes
  useEffect(() => {
    if (isClient) {
      const container = document.querySelector('.filters-bar-container');
      setFiltersBarContainer(container);
    }
  }, [isClient, listView, layoutType, width]);

  const showFiltersAtTheBottomOfTheList = !isDesktop && !!filtersBarContainer;

  const filters = (
    <HorizontalFilters
      routeType={routeType}
      isWaiting={isWaiting}
      isLoading={isLoading}
      dynamicFiltersResponse={dynamicFiltersResponse}
      handleShowFilters={handleShowFilters}
    />
  );

  if (showFiltersAtTheBottomOfTheList) return createPortal(filters, filtersBarContainer);

  return filters;
};

export default FiltersBarContainer;
